/**
 * GoogleMSP and GoogleMSSP Section 0 rewuest widget form IDs for static handling
 */
export enum GoogleMSPAuditSection0RequestWidgetIds {
    GoogleMspSection0 = '6aafccbb-a3ce-4dde-9602-339f1469c1cb',
    GoogleMsspSection0 = '68b64181-eb9b-4a2d-9478-5954f849d35a',
}
